import type {Asset, FocalPointAsset, FromResolver, Rendition} from "@magnolia/vue-editor";
import type {KeysMatching} from "#base-layer/types/KeysMatching";
import {didResolve} from "#magnolia-layer/utils/link-utils";

// export const getAssetLink = (asset: FromResolver<Asset | FocalPointAsset>, rendition?: string): string | undefined => {
//   // if (process.client) {
//   //   alert("MGNL");
//   // }
//   if (didResolve(asset)) {
//     if ((asset as unknown as Asset<[""]>).renditions && rendition) {
//       const link = (asset.renditions as unknown as Record<string, Rendition>)[rendition]?.link as string | undefined;
//       if (!link) throw Error(`No rendition [${rendition}] found for asset [${asset["@path"]}].`);
//       return link;
//     }
//     const link = asset['@link'];
//     if (!link) {
//       throw new Error(`No link found for asset: '${asset["@id"]}', is in the correct path? And/or are the rights setup appropriately?`);
//     }
//     return link;
//   }
// }


type GenericAsset = Asset<ReadonlyArray<string> | undefined>;

type Wrap<T> = FromResolver<T> | T;

export function getAssetLink<
  A extends Wrap<GenericAsset | FocalPointAsset>,
  R extends (A extends GenericAsset ? KeysMatching<A['renditions'], Rendition> : never)
>(
  asset: A,
  rendition?: R | unknown
) {
  if (!didResolve<GenericAsset | FocalPointAsset>(asset)) {
    return;
  }
  let link;
  if (!asset.renditions || !rendition) {
    link = asset["@link"];
  } else if (!asset.renditions[rendition as string]) {
    link = asset["@link"];
  } else {
    link = asset.renditions[rendition as string].link;
  }
  if (!link) {
    throw new Error(`No link found for asset: '${asset["@id"]}', is in the correct path? And/or are the rights setup appropriately?`);
  }
  return link;
}
